"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.colors = void 0;
exports.colors = {
    baseDark: "#414141",
    baseLight: "#FFF",
    error: "#b24135",
    success: "#56BB00",
    disabled: "#D8D8D8",
    primary: "#0b2641",
    secondary: "#83389E",
    action: "#25b3eb",
    lightGray: "#f7f7f7",
    darkGray: "#595959",
    mustard: "#cfae40 ",
    avocado: "#98b235",
    green: "#86B049",
    lightGreen: "#e2edd9",
};
exports.typography = {
    primaryFont: "'Open Sans', sans-serif",
    secondaryFont: "'Open Sans', sans-serif",
};
//# sourceMappingURL=variables.js.map